import React, { useState, useEffect } from "react";
import { Badge, Drawer, Card } from "antd";
import { BellOutlined, CloseOutlined } from "@ant-design/icons";
import { ExpenseServices } from "../../Services/Manage/ExpenseServices";

const QuickMessage = () => {
  const [open, setOpen] = useState(false);
  const [recentExpenses, setRecentExpenses] = useState([]);

  useEffect(() => {
    const fetchRecentExpenses = async () => {
      try {
        const res = await ExpenseServices.getRecentExpenses();
        if (res.status && res.data && res.data.length > 0) {
          setRecentExpenses(res.data);
        }
      } catch (error) {
        console.error("Error fetching recent expenses:", error);
      }
    };
    fetchRecentExpenses();
  }, []);

  const handleBellClick = async () => {
    setOpen(true);

    try {
      const res = await ExpenseServices.getRecentExpenses();
      if (res.status && res.data && res.data.length > 0) {
        setRecentExpenses(res.data);
      } else {
        setRecentExpenses([]);
      }
    } catch (error) {
      console.error("Error fetching recent expenses:", error);
      setRecentExpenses([]);
    }
  };

  const handleCloseNotification = (id) => {
    setRecentExpenses((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <>
      <Badge count={recentExpenses.length} offset={[5, 0]}>
        <BellOutlined
          style={{ fontSize: 22, cursor: "pointer", color: "#3b94e2ff" }}
          onClick={handleBellClick}
        />
      </Badge>

      <Drawer
        title={<b>Notifications</b>}
        placement="right"
        open={open}
        onClose={() => setOpen(false)}
        width={360}
        closable={true}
        bodyStyle={{
  
          padding: "12px",
          overflowY: "auto",
          height: "100%",
        }}
      >
        {recentExpenses.length > 0 ? (
          <div className="flex flex-col gap-3">
            {recentExpenses.map((expense) => (
              <Card
                key={expense.id}
                size="small"
                style={{
                  borderRadius: 10,
                  backgroundColor: "#fff",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  marginBottom: 12,
                  border: "1px solid #e5e7eb",
                  position: "relative", 
                }}
              >
                <CloseOutlined
                  onClick={() => handleCloseNotification(expense.id)}
                  style={{
                    position: "absolute",
                    top: 8,
                    right: 10,
                    fontSize: 14,
                    color: "#999",
                    cursor: "pointer",
                  }}
                />

                <div style={{ paddingRight: 20 }}>
                  <div style={{ fontWeight: "bold", fontSize: "15px" }}>
                   Subscription Due | {expense.description || "New Expense"}
                  </div>
                  <div style={{ fontSize: "13px", color: "#555" }}>
                    Subscription Date: {expense.expense_date}
                  </div>
                  <div style={{ fontSize: "13px", color: "#555" }}>
                    Type: {expense.subscription_type || "N/A"}
                  </div>
                </div>
              </Card>
            ))}
          </div>
        ) : (
          <p style={{ textAlign: "center", color: "#888", marginTop: "20px" }}>
            No recent expenses within 7 days.
          </p>
        )}
      </Drawer>
    </>
  );
};

export default QuickMessage;
